import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=ec9928fc&lang=pug"
import script from "./AlertForm.vue?vue&type=script&lang=js"
export * from "./AlertForm.vue?vue&type=script&lang=js"
import style0 from "./AlertForm.vue?vue&type=style&index=0&id=ec9928fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports